import { render, staticRenderFns } from "./UserImportClient.vue?vue&type=template&id=50ba71b2"
import script from "./UserImportClient.vue?vue&type=script&lang=js"
export * from "./UserImportClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports